(function ($) {
    EqUI.app_bar = {};

    // Init
    EqUI.app_bar.init = function() {
        // Global vars
        EqUI.app_bar.element = $('.eq-ui-app-bar');
    };

    // Update
    EqUI.app_bar.update = function() {
        
        if (window.innerWidth > 768) {
            
            //...
        }
        else {

            //...
        }
    };

    $(document).ready(function() {
        // Init
        EqUI.app_bar.init();

        // Update
        EqUI.app_bar.update();
    });
}( jQuery ));
